module.exports = __webpack_public_path__ + "static/media/login-bg-2-success.1ae25a8e.png";